import styled from 'styled-components';

const Card = styled.div`
  box-sizing: border-box;
  max-width: 410px;
  margin: 0 auto;
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border: 1px solid #ddd;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 12px;
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Input = styled.input`
  padding: 1rem;
  border: 1px solid #999;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 0.8rem;
  background-color: #fff;
  color: #000;
`;

const Button = styled.button`
  background: white;
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  color: black;
  font-weight: 700;
  width: 100%;
  margin-bottom: 1rem;
  font-size: 0.8rem;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: black;
  }
`;

const Logo = styled.img`
  width: 50%;
  margin-bottom: 1rem;
`;

const FormError = styled.div`
  background-color: tomato;
  margin: 0.5rem 0.5rem;
  padding: 0.5rem 0.5rem;
  border-radius: 8px;
  color: white;
  font-size: 0.75rem;
`;

export { Form, Input, Button, Logo, Card, FormError };
